import { completedList, newList } from '@/mocks/comics';
import ComicCard from './ComicCard';

export default function LibrarySection() {
  return (
    <section id="new" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
          <div>
            <p className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium mb-3">
              <i className="ri-sparkling-2-fill"></i>
              新上架作品
            </p>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              新鲜故事，抢先开读
            </h2>
            <p className="mt-2 text-foreground-600 text-sm">平台最新上线的连载新作，第一时间发现好故事。</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5">
          {newList.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div id="completed" className="scroll-mt-20 mt-14 md:mt-20 flex items-end justify-between flex-wrap gap-4 mb-8">
          <div>
            <p className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-3">
              <i className="ri-checkbox-circle-fill"></i>
              完结作品库
            </p>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              经典完结，一次看个够
            </h2>
            <p className="mt-2 text-foreground-600 text-sm">已完结长篇作品库，适合一口气追完，重温经典。</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5">
          {completedList.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}